import LiveShowItem from "./liveshowItem.js";
import {useEffect, useState} from "react";
import axios from "axios";
import SimpleBackdrop from "./background";
import {addTokenHistory, valideLogin} from "../login/UserService";
import "./config.css"
import {getEvents, getSaveChannels} from "../globalMethods/myConfig";
import {getLiveMacSafari} from "../globalMethods/utils";
const  LiveShowItems = () =>{

    const [channels, setChannels] = useState([])

    //api/initialTV

    const [showEvents, setShowEvents] = useState([])

    const [liveToken, setLiveToken] = useState("")

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        const checkChannelList = async (serverChannelList, localChannelList) => {
           if (serverChannelList.length !== localChannelList.length) {
              await  reInitialTv()
           }
        }

        const getServerChannelList = async (outData) => {

            let channelsData = []

            for (let channelGroups of outData?.PDS?.ChannelsGroups?.ChannelsGroup) {

                for (let channel of channelGroups?.Channels) {
                    
                    if (channel.AccessRights?.NoAccess === "false") {
                        channelsData.push(channel)
                    }
                    else channelsData.push(channel)

                }
            }
            return channelsData

        }

        const reInitialTv = async () => {

            let uri = getLiveMacSafari() ? "api/initialSafariMacTV" : "api/initialTV"
            const initialTV = await axios.get(global.serverEndpoint + uri  )
            const outData = initialTV.data?.ServiceResponse?.OutData
            window.localStorage.setItem("LiveToken", outData?.LiveToken)
            window.localStorage.setItem("RMUToken", outData?.RMUToken)
            window.localStorage.setItem("TokenCreatedDate", new Date().getTime().toString())
            setLiveToken(outData?.LiveToken)
            await addTokenHistory(outData?.LiveToken, outData?.RMUToken )
            const channelsData = await getServerChannelList(outData)
            window.sessionStorage.setItem("Channels", JSON.stringify(channelsData))
            setChannels(channelsData)

        }
       const getChannels = async () =>{

           setIsLoading(true)

           await reInitialTv()
           const eventShows = await getEvents()
           setShowEvents(eventShows)

           /*
           if(!tokenLive){
               await reInitialTv()
           }
           else  {
               const createdLiveTokenDate = window.localStorage.getItem("TokenCreatedDate")
               if(createdLiveTokenDate){
                   const tokenLiveDate = new Date(parseInt(createdLiveTokenDate));
                   const endingDate =  tokenLiveDate.setHours(tokenLiveDate.getHours() + 1) ;
                   const nowTimeDate = new Date().getTime()
                   if(endingDate< nowTimeDate){
                       await reInitialTv()
                   }
               }
               const channelStorage = getSaveChannels()
               if(channelStorage){
                   let uri = getLiveMacSafari() ? "api/initialSafariMacTV" : "api/initialTV"
                   const initialTV = await axios.get(global.serverEndpoint + uri)
                   const outData = initialTV.data?.ServiceResponse?.OutData
                   const channelsData = await getServerChannelList(outData)
                   await checkChannelList(channelStorage, channelsData)
                   setChannels(channelsData)

               }
               setLiveToken(tokenLive)
           }
           */
           setIsLoading(false)
       }
       getChannels()

    }, [channels.length, liveToken]);
    return <>
        {
            isLoading ? <SimpleBackdrop open={true}></SimpleBackdrop>
                : <div style={{backgroundColor: "black"}}>

                    <div style={{
                        flexDirection: "row",
                        marginTop: -30,
                        marginLeft:20,
                        color: "white",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent:"space-between"
                    }}>

                        {channels.map((channel) => {

                            const showsFoundEvent = showEvents.filter((showEvent) => showEvent.id === parseInt(channel?.EpgId))
                            let showsEvent
                            if (showsFoundEvent.length === 1) {
                                showsEvent = showsFoundEvent[0]?.events
                            }
                            if (!channel?.Name.includes("EVENT EXPERT"))
                                return <LiveShowItem key={channel?.id} showEvents={showsEvent} channel={channel}
                                                     liveToken={liveToken}></LiveShowItem>
                            return <div key={channel?.id}>
                            </div>
                        })}
                    </div>


                </div>
        }
    </>


}


export default LiveShowItems